import { Action, createAsyncAction, createReducer } from 'typesafe-actions';
import { produce } from 'immer';
import type { ReduxError } from '@universal/errors';
import { CenterType } from '../../../../types/centerType';
import { CenterProductsType } from '../../../../types/centerProductsType';

// Actions
export enum Actions {
  GET_CENTERS = 'naf/centers/GET_CENTERS',
  GET_CENTERS_SUCCESS = 'naf/centers/GET_CENTERS_SUCCESS',
  GET_CENTERS_FAIL = 'naf/centers/GET_CENTERS_FAIL',
  GET_CENTERS_CANCEL = 'naf/centers/GET_CENTERS_CANCEL',
  GET_CENTER_PRODUCTS = 'naf/centers/GET_PRODUCTS',
  GET_CENTER_PRODUCTS_SUCCESS = 'naf/centers/GET_PRODUCTS_SUCCESS',
  GET_CENTER_PRODUCTS_FAIL = 'naf/centers/GET_PRODUCTS_FAIL',
  GET_CENTER_PRODUCTS_CANCEL = 'naf/centers/GET_PRODUCTS_CANCEL',
}

export interface State {
  centerList: {
    data: CenterType[] | null;
    isUpdating: boolean;
    error: ReduxError | null;
  };
  centerProducts: {
    data: CenterProductsType[] | null;
    isUpdating: boolean;
    error: ReduxError | null;
  };
}

export const initialState: State = {
  centerList: {
    data: null,
    isUpdating: false,
    error: null,
  },
  centerProducts: {
    data: null,
    isUpdating: false,
    error: null,
  },
};

export const actions = {
  getCenters: createAsyncAction(
    Actions.GET_CENTERS, // request payload creator
    Actions.GET_CENTERS_SUCCESS, // success payload creator
    Actions.GET_CENTERS_FAIL, // failure payload creator
    Actions.GET_CENTERS_CANCEL, // optional cancel payload creator
  )<undefined, CenterType[], ReduxError, undefined>(),
  getCenterProducts: createAsyncAction(
    Actions.GET_CENTER_PRODUCTS, // request payload creator
    Actions.GET_CENTER_PRODUCTS_SUCCESS, // success payload creator
    Actions.GET_CENTER_PRODUCTS_FAIL, // failure payload creator
    Actions.GET_CENTER_PRODUCTS_CANCEL, // optional cancel payload creator
  )<number | undefined, CenterProductsType[], ReduxError, undefined>(),
};

export const reducers = createReducer<State, Action>(initialState, {})
  .handleAction(actions.getCenters.request, (state = initialState) =>
    produce(state, (draftState) => {
      draftState.centerList.isUpdating = true;
      draftState.centerList.error = undefined;
    }),
  )
  .handleAction(actions.getCenters.success, (state = initialState, action) =>
    produce(state, (draftState) => {
      draftState.centerList.isUpdating = false;
      draftState.centerList.data = action.payload;
    }),
  )
  .handleAction(actions.getCenters.failure, (state = initialState, action) =>
    produce(state, (draftState) => {
      draftState.centerList.isUpdating = false;
      draftState.centerList.error = action.payload;
    }),
  )
  .handleAction(actions.getCenters.cancel, (state = initialState) =>
    produce(state, (draftState) => {
      draftState.centerList.isUpdating = false;
    }),
  )
  .handleAction(actions.getCenterProducts.request, (state = initialState) =>
    produce(state, (draftState) => {
      draftState.centerProducts.isUpdating = true;
      draftState.centerProducts.error = undefined;
    }),
  )
  .handleAction(actions.getCenterProducts.success, (state = initialState, action) =>
    produce(state, (draftState) => {
      draftState.centerProducts.isUpdating = false;
      draftState.centerProducts.data = action.payload;
    }),
  )
  .handleAction(actions.getCenterProducts.failure, (state = initialState, action) =>
    produce(state, (draftState) => {
      draftState.centerProducts.isUpdating = false;
      draftState.centerProducts.error = action.payload;
    }),
  )
  .handleAction(actions.getCenterProducts.cancel, (state = initialState) =>
    produce(state, (draftState) => {
      draftState.centerProducts.isUpdating = false;
    }),
  );
